import HttpV2 from './HttpV2';

class GlobalReportServiceV2 {
  static async getPerAgency(filters) {
    return HttpV2.get('global-reports/agencies', {
      params: filters,
    });
  }

  static async getPerPackage(filters) {
    return HttpV2.get('global-reports/packages', {
      params: filters,
    });
  }

  static async getStats(filters) {
    return HttpV2.get('global-reports/stats', {
      params: filters,
    });
  }

  static async exportCsv(filters) {
    return HttpV2.get('global-reports/export-csv', {
      responseType: 'blob',
      params: filters,
    });
  }
}

export default GlobalReportServiceV2;
